"use client";

import { Button } from "@watt/ui/components/ui/button";
import { cn } from "@watt/ui/utils/classname-tailwind-merge";
import type React from "react";
import { useVerification } from "./verification-context";

export interface VerificationCancelProps
  extends Omit<React.ComponentPropsWithoutRef<typeof Button>, "onClick"> {
  ref?: React.Ref<HTMLButtonElement>;
}

export function VerificationCancel({
  children = "Cancel",
  className,
  variant = "link",
  size = "sm",
  ref,
  ...props
}: VerificationCancelProps) {
  const { actions } = useVerification();

  return (
    <Button
      className={cn("h-auto p-0", className)}
      onClick={actions.cancel}
      ref={ref}
      size={size}
      type="button"
      variant={variant}
      {...props}
    >
      {children}
    </Button>
  );
}
